export default __webpack_public_path__ + "static/media/icons-services.6fbd3c06.svg";